import React from 'react';
import ReactDOM from 'react-dom/client';
import OptimalAvailabilityStudio from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <OptimalAvailabilityStudio />
  </React.StrictMode>
);
